var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: { title: _vm.pageTitle, "back-url": "/market/life-vibes-point" },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c("div", { staticClass: "page-tip" }, [
            _c("i", { staticClass: "el-icon-info" }),
            _c("span", [
              _vm._v(
                "点位类型为集市且认证状态为已认证时，请直接选择已有集市，系统会自动同步地址、坐标和城市信息；城市信息统一通过省市区级联选择并自动带入编码提交。"
              ),
            ]),
          ]),
          _c(
            "el-form",
            {
              ref: "formRef",
              staticClass: "formValidate",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("基础信息")]),
              _c(
                "el-form-item",
                { attrs: { label: "点位图片：", prop: "pointImg" } },
                [
                  _c("div", { staticClass: "upload-images-container" }, [
                    _c("div", { staticClass: "upload-tips" }, [
                      _c("span", [_vm._v("支持多图上传，最多 9 张")]),
                      _c("span", { staticClass: "image-count" }, [
                        _vm._v(_vm._s(_vm.form.pointImg.length) + "/9"),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "image-list" },
                      [
                        _vm._l(_vm.form.pointImg, function (image, index) {
                          return _c(
                            "div",
                            {
                              key: "point-image-" + index,
                              staticClass: "image-item",
                            },
                            [
                              _c("el-image", {
                                staticClass: "image-preview",
                                attrs: {
                                  src: image,
                                  "preview-src-list": _vm.form.pointImg,
                                  fit: "cover",
                                },
                              }),
                              _c("i", {
                                staticClass: "el-icon-error btndel",
                                on: {
                                  click: function ($event) {
                                    return _vm.removePointImage(index)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        _vm.form.pointImg.length < 9
                          ? _c(
                              "div",
                              {
                                staticClass: "upload-item",
                                on: { click: _vm.uploadPointImage },
                              },
                              [
                                _c("i", { staticClass: "el-icon-plus" }),
                                _c("div", { staticClass: "upload-text" }, [
                                  _vm._v("上传图片"),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "点位名称：", prop: "pointName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "50",
                              "show-word-limit": "",
                              placeholder: "请输入点位名称",
                            },
                            model: {
                              value: _vm.form.pointName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "pointName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.pointName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "简介内容：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: "300",
                      "show-word-limit": "",
                      placeholder: "请输入公开展示的精简润色内容",
                    },
                    model: {
                      value: _vm.form.content,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "content",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.content",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "标签：" } }, [
                        _c("div", { staticClass: "tag-editor" }, [
                          _vm.form.tags.length
                            ? _c(
                                "div",
                                { staticClass: "tag-list" },
                                _vm._l(_vm.form.tags, function (tag, index) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: tag + "-" + index,
                                      staticClass: "tag-item",
                                      attrs: { closable: "", size: "medium" },
                                      on: {
                                        close: function ($event) {
                                          return _vm.removeTag(index)
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(tag) + " ")]
                                  )
                                }),
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "tag-input-row" },
                            [
                              _c("el-input", {
                                ref: "tagInputRef",
                                attrs: {
                                  maxlength: "20",
                                  placeholder: "请输入单个标签后点击添加",
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleTagInputConfirm($event)
                                  },
                                },
                                model: {
                                  value: _vm.tagInputValue,
                                  callback: function ($$v) {
                                    _vm.tagInputValue =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "tagInputValue",
                                },
                              }),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", plain: "" },
                                  on: { click: _vm.handleTagInputConfirm },
                                },
                                [_vm._v("添加标签")]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "每次输入一个标签，可单独删除，最多 20 个。"
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "浏览数：" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 0,
                              precision: 0,
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.form.readCount,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "readCount", $$v)
                              },
                              expression: "form.readCount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "点位类型：", prop: "pointType" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择点位类型" },
                              on: { change: _vm.handlePointTypeChange },
                              model: {
                                value: _vm.form.pointType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "pointType", $$v)
                                },
                                expression: "form.pointType",
                              },
                            },
                            _vm._l(_vm.pointTypeOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "认证状态：",
                            prop: "merchantStatus",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.handleMerchantStatusChange },
                              model: {
                                value: _vm.form.merchantStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "merchantStatus", $$v)
                                },
                                expression: "form.merchantStatus",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("未认证/未入驻"),
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("已认证/已入驻"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isMarketBindingMode
                ? _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "关联集市：", prop: "marketId" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "请选择已有集市",
                                    loading: _vm.marketLoading,
                                  },
                                  on: {
                                    focus: _vm.loadMarketOptions,
                                    change: _vm.handleMarketChange,
                                  },
                                  model: {
                                    value: _vm.form.marketId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "marketId", $$v)
                                    },
                                    expression: "form.marketId",
                                  },
                                },
                                _vm._l(_vm.marketOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.marketName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                              _c("div", { staticClass: "from-tips" }, [
                                _vm._v(
                                  "选择已有集市后，会自动带入集市坐标、地址和城市信息；带入后仍支持按实际情况修改城市信息。"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "section-title" }, [_vm._v("城市信息")]),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "省市区：" } },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.regionOptions,
                              props: _vm.regionProps,
                              filterable: "",
                              clearable: "",
                              placeholder: "请选择省/市/区",
                            },
                            on: { change: _vm.handleRegionChange },
                            model: {
                              value: _vm.selectedRegion,
                              callback: function ($$v) {
                                _vm.selectedRegion = $$v
                              },
                              expression: "selectedRegion",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "请选择到区县后会自动生效；编码仅用于接口提交，页面不展示。"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "section-title" }, [_vm._v("地图选点")]),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "详细地点：", prop: "location" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                disabled: _vm.isMarketBindingMode,
                                readonly: "",
                                placeholder: _vm.isMarketBindingMode
                                  ? "已由关联集市自动带入"
                                  : "请通过地图选择点位",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.openMapDialog($event)
                                },
                              },
                              model: {
                                value: _vm.form.location,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "location", $$v)
                                },
                                expression: "form.location",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "append",
                                    icon: "el-icon-location",
                                    disabled: _vm.isMarketBindingMode,
                                  },
                                  on: { click: _vm.openMapDialog },
                                  slot: "append",
                                },
                                [_vm._v(" 地图选点 ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "from-tips" },
                            [
                              _vm.isMarketBindingMode
                                ? [
                                    _vm._v(
                                      " 当前为集市自动带入模式，已禁用手动地图选点。 "
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      " 点击输入框或按钮，在地图中选择位置后会自动回填经纬度和城市信息。 "
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "经度：", prop: "lng" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "", placeholder: "自动回填" },
                            model: {
                              value: _vm.form.lng,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "lng", $$v)
                              },
                              expression: "form.lng",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "纬度：", prop: "lat" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "", placeholder: "自动回填" },
                            model: {
                              value: _vm.form.lat,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "lat", $$v)
                              },
                              expression: "form.lat",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isEdit
                ? _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建时间：" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.form.createTime || "-",
                                  disabled: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "更新时间：" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.form.updateTime || "-",
                                  disabled: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "btn-container" },
                [
                  _c("el-button", { on: { click: _vm.handleCancel } }, [
                    _vm._v("取消"),
                  ]),
                  _vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["platform:lifeVibesPoint:update"],
                              expression: "['platform:lifeVibesPoint:update']",
                            },
                          ],
                          attrs: {
                            type: "primary",
                            loading: _vm.submitLoading,
                          },
                          on: { click: _vm.handleSubmit },
                        },
                        [_vm._v(" 保存修改 ")]
                      )
                    : _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["platform:lifeVibesPoint:save"],
                              expression: "['platform:lifeVibesPoint:save']",
                            },
                          ],
                          attrs: {
                            type: "primary",
                            loading: _vm.submitLoading,
                          },
                          on: { click: _vm.handleSubmit },
                        },
                        [_vm._v(" 立即创建 ")]
                      ),
                  !_vm.hasSubmitPermission
                    ? _c("el-alert", {
                        staticClass: "submit-permission-tip",
                        attrs: {
                          title:
                            "当前账号没有该页面的提交权限，可查看但不能保存。",
                          type: "warning",
                          closable: false,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "map-dialog",
          attrs: {
            title: "地图选择位置",
            visible: _vm.mapDialogVisible,
            width: "1200px",
            "before-close": _vm.handleMapDialogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.mapDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "map-dialog-content" }, [
            _c(
              "div",
              { staticClass: "search-section" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 16 } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              filterable: "",
                              remote: "",
                              "reserve-keyword": "",
                              placeholder: "请输入地点名称搜索",
                              "remote-method": _vm.searchLocation,
                              loading: _vm.searchLoading,
                              size: "large",
                              "no-data-text": _vm.searchNoDataText,
                            },
                            on: {
                              change: _vm.handleSearchResultChange,
                              "visible-change": _vm.handleSelectVisibleChange,
                            },
                            model: {
                              value: _vm.selectedSearchResult,
                              callback: function ($$v) {
                                _vm.selectedSearchResult = $$v
                              },
                              expression: "selectedSearchResult",
                            },
                          },
                          [
                            _vm._l(_vm.searchResults, function (result, index) {
                              return _c(
                                "el-option",
                                {
                                  key: index,
                                  attrs: { label: result.name, value: result },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "search-option-item" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "option-name" },
                                        [_vm._v(_vm._s(result.name))]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "option-address" },
                                        [_vm._v(_vm._s(result.address))]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            _vm.hasMoreResults
                              ? _c(
                                  "el-option",
                                  {
                                    key: "load-more",
                                    staticClass: "load-more-option",
                                    attrs: { value: null, disabled: true },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "load-more-section" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "load-more-btn",
                                            attrs: {
                                              type: "text",
                                              loading: _vm.loadingMore,
                                            },
                                            on: {
                                              click: _vm.loadMoreResults,
                                              mousedown: function ($event) {
                                                $event.stopPropagation()
                                              },
                                              mouseup: function ($event) {
                                                $event.stopPropagation()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.loadingMore
                                                    ? "加载中..."
                                                    : "加载更多"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c(
                        "div",
                        { staticClass: "search-buttons" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: { click: _vm.handleLocationClick },
                            },
                            [_vm._v("定位当前位置")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: { click: _vm.handleMapDialogClose },
                            },
                            [_vm._v("取消")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                disabled: !_vm.selectedAddress,
                              },
                              on: { click: _vm.confirmLocation },
                            },
                            [_vm._v(" 确认选择 ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "map-section" }, [
              _c("div", {
                staticClass: "map-container",
                attrs: { id: "lifeVibesMapContainer" },
              }),
            ]),
            _vm.selectedAddress
              ? _c("div", { staticClass: "selection-result" }, [
                  _c("div", { staticClass: "result-card" }, [
                    _c("div", { staticClass: "result-header" }, [
                      _c("span", { staticClass: "result-title" }, [
                        _c("i", { staticClass: "el-icon-location-outline" }),
                        _vm._v(" 已选择位置 "),
                      ]),
                    ]),
                    _c("div", { staticClass: "result-content" }, [
                      _c("div", { staticClass: "main-address" }, [
                        _vm._v(
                          _vm._s(
                            _vm.selectedLocationName || _vm.selectedAddress
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "coordinate-info" }, [
                        _c("span", { staticClass: "coords" }, [
                          _vm._v(
                            "坐标：" +
                              _vm._s(_vm.selectedLng) +
                              ", " +
                              _vm._s(_vm.selectedLat)
                          ),
                        ]),
                        _vm.selectedAddressDetail &&
                        _vm.selectedAddressDetail.addressComponent &&
                        _vm.selectedAddressDetail.addressComponent.city
                          ? _c("span", { staticClass: "city" }, [
                              _vm._v(
                                " | 城市：" +
                                  _vm._s(
                                    _vm.selectedAddressDetail.addressComponent
                                      .city
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        _vm.selectedAddressDetail &&
                        _vm.selectedAddressDetail.addressComponent &&
                        (_vm.selectedAddressDetail.addressComponent.district ||
                          _vm.selectedAddressDetail.addressComponent.county)
                          ? _c("span", { staticClass: "district" }, [
                              _vm._v(
                                " | 区县：" +
                                  _vm._s(
                                    _vm.selectedAddressDetail.addressComponent
                                      .district ||
                                      _vm.selectedAddressDetail.addressComponent
                                        .county
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }